<template>
    <v-card flat>
        <node-edit v-bind="{ value, width }" v-on="{ sync, emit }">
            <template #activator="{ attrs, on }">
                <v-btn v-bind="{ ...props, ...attrs }" v-on="on">
                    <template v-if="isDone">
                        <span class="mr-8"> {{ typeText }} 완료 </span>
                        <v-icon> mdi-checkbox-marked </v-icon>
                    </template>
                    <template v-else>
                        <span class="mr-8"> {{ typeText }} 대기 </span>
                        <v-icon> mdi-checkbox-blank-outline </v-icon>
                    </template>
                </v-btn>
            </template>
            <template v-slot="{ save }">
                <template v-if="value.type == EMPLOYMENT_FIELD_TYPES.CBOX.value">
                    <v-simple-checkbox v-model="form.data" color="primary" />
                </template>
                <template v-if="value.type == EMPLOYMENT_FIELD_TYPES.DATE.value">
                    <v-text-field v-model="form.data" type="date" clearable autofocus @keydown.enter.prevent="save" />
                </template>
                <template v-if="value.type == EMPLOYMENT_FIELD_TYPES.SIGN.value">
                    <node-sign-form v-model="form.img" v-on="{ sync }" />
                </template>
                <template v-if="value.type == EMPLOYMENT_FIELD_TYPES.TEXT.value">
                    <v-text-field v-model="form.data" clearable autofocus @keydown.enter.prevent="save" />
                </template>
            </template>
        </node-edit>
    </v-card>
</template>

<script>
import { EMPLOYMENT_FIELD_TYPES, initEmploymentField } from "@/assets/variables";

import NodeEdit from "../item/node/node-edit.vue";
import NodeSignForm from "../item/node/node-sign-form.vue";

export default {
    components: {
        NodeEdit,
        NodeSignForm,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentField>} */
        value: { type: Object, default: initEmploymentField },
    },
    data: () => ({
        form: initEmploymentField(),
        EMPLOYMENT_FIELD_TYPES,
    }),
    computed: {
        props() {
            if (this.isDone) {
                return {
                    outlined: true,
                    color: "primary",
                };
            }
            return {
                outlined: true,
            };
        },
        isDone() {
            let { type, img, data } = this.value;
            switch (type) {
                case EMPLOYMENT_FIELD_TYPES.SIGN.value: {
                    return !!img;
                }
                default: {
                    return !!data;
                }
            }
        },
        width() {
            let { type } = this.value;
            switch (type) {
                case EMPLOYMENT_FIELD_TYPES.CBOX.value: {
                    return 240;
                }
                case EMPLOYMENT_FIELD_TYPES.DATE.value: {
                    return 240;
                }
                case EMPLOYMENT_FIELD_TYPES.SIGN.value: {
                    return 480;
                }
                case EMPLOYMENT_FIELD_TYPES.TEXT.value: {
                    return 320;
                }
            }
        },
        typeText() {
            return this.value.isRequired ? "필수입력" : "선택입력";
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentField(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style></style>
